import React from 'react';
import { Radio, Form } from 'antd';
import './style.css';

/**
 * Props for the FormRadioGroup component.
 */
interface FormRadioGroupProps {
  /** Label text for the radio group. */
  label?: string;
  /** Name of the form field. */
  name: string | string[];
  /** Selected value of the radio group. */
  value?: string | number | boolean;
  /** Validation rules for the form item. */
  rules?: React.ComponentProps<typeof Form.Item>['rules'];
  /** Child elements, typically Radio components. */
  children: React.ReactNode;
  /** Custom styles for the form item containing the radio group. */
  formItemStyles?: React.CSSProperties;
  /** Whether the radio group is disabled. */
  disabled?: boolean;
  /** Custom class name for additional styling. */
  className?: string;
  /** Callback function triggered when the radio group value changes. */
  onChange?: (value: unknown) => void;
}

/**
 * A form-compatible radio group component using Ant Design's Form and Radio.Group.
 *
 * @param {FormRadioGroupProps} props - The component props.
 * @returns {JSX.Element} The rendered FormRadioGroup component.
 */
const FormRadioGroup: React.FC<FormRadioGroupProps> = ({
  label = '',
  name,
  onChange,
  value,
  rules = [],
  children,
  formItemStyles = {},
  disabled = false,
  ...extra
}) => {
  return (
    <Form.Item
      initialValue={value}
      rules={rules}
      label={label}
      name={name}
      {...extra}
      style={{ width: '100%', marginBottom: '0px' }}
    >
      <Radio.Group
        onChange={onChange}
        value={value}
        disabled={disabled}
        style={formItemStyles}
        className="FormRadioGroup"
        id="FormRadioGroup"
      >
        {children}
      </Radio.Group>
    </Form.Item>
  );
};

export default FormRadioGroup;
